import { Typography, styled } from '@mui/material';

export const GilroyTypo = styled(Typography)({
  fontFamily: 'Gilroy-Medium, sans-serif',
});

export const RedHatTypo = styled(Typography)({
  fontFamily: 'Red Hat Display, sans-serif',
});
